import { render, staticRenderFns } from "./productTag__list.vue?vue&type=template&id=3c12a786"
import script from "./productTag__list.vue?vue&type=script&lang=js"
export * from "./productTag__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports